import { type ConversionRateCardState, ConversionRateCardShell } from "../../shared/ConversionRateCardShell";

import type { IPopCardAutomationIds } from "./automationIds";
import { ConversionRatePopBars } from "./ConversionRatePopBars";

interface IConversionRateOverviewPopCardProps {
    title: string;
    tooltip: string;
    dateRangeText: string;
    countryCode: number;
    countryText: string;
    state: ConversionRateCardState;
    comparedRowLabel: string;
    currentRowLabel: string;
    originalValue?: number | null;
    comparedValue?: number | null;
    change?: number | null;
    changeSuffix: string;
    formatValue: (value: number) => string;
    formatChange: (change: number) => string;
    automationIds: IPopCardAutomationIds;
}

export const ConversionRateOverviewPopCard = ({
    title,
    tooltip,
    dateRangeText,
    countryCode,
    countryText,
    state,
    comparedRowLabel,
    currentRowLabel,
    originalValue,
    comparedValue,
    change,
    changeSuffix,
    formatValue,
    formatChange,
    automationIds,
}: IConversionRateOverviewPopCardProps) => {
    if (state === "available" && (originalValue == null || comparedValue == null)) {
        return null;
    }

    return (
        <ConversionRateCardShell
            title={title}
            tooltip={tooltip}
            dateRangeText={dateRangeText}
            countryCode={countryCode}
            countryText={countryText}
            state={state}
            cardAutomationId={automationIds.card}
            lockedCtaAutomationId={automationIds.lockedCta}
            loadingRowCount={2}
        >
            {originalValue != null && comparedValue != null ? (
                <ConversionRatePopBars
                    comparedRowLabel={comparedRowLabel}
                    currentRowLabel={currentRowLabel}
                    comparedValue={comparedValue}
                    originalValue={originalValue}
                    change={change}
                    changeSuffix={changeSuffix}
                    formatValue={formatValue}
                    formatChange={formatChange}
                    automationIds={automationIds}
                />
            ) : null}
        </ConversionRateCardShell>
    );
};
